import React from 'react';
import useSWR from 'swr';
import Loading from '@/components/Loading/Loading';
import CollectionsSlider from './CollectionsSlider';
import { TopDealProduct } from '@/lib/hot-deals/helpers';
import Section from '../commons/Section';

export default function HotDealSlider({
  isAccount,
}: {
  isHomepage?: boolean;
  isAccount?: boolean;
}) {
  const { data: deals } = useSWR<TopDealProduct[]>(() => `/api/topdeals`);
  const title = isAccount ? `Today's Deals` : 'Hot Deals';

  const config = {
    title,
    dealTitle: 'All Hot Deals',
    collectionHandle: 'hot-deals',
    collections: [],
    deals: deals?.slice(0, 9),
  };

  if (!deals) {
    return (
      <div className="my-10 xxs:my-12 xs:my-14 md:my-16 lg:my-20">
        <Loading />
      </div>
    );
  }

  if (deals.length > 0) {
    return (
      <Section className="py-8">
        <CollectionsSlider
          title={config.title}
          dealTitle={config.dealTitle}
          collectionHandle={config.collectionHandle}
          offers={config.collections}
          deals={config.deals}
        />
      </Section>
    );
  }

  return null;
}
